import organization from "@/config/organization";

export const mixCredentials = function (userid, password,force=true) {
    const token = userid+":"+password;
    return mixToken(token, force);
}

export const mixToken = function (token, force) {

    if (force || organization.encrypt_token) {

        const timestamp = Date.now().toString();
        const to_encode = encodeURIComponent(token) + "_" + timestamp;
        const reversed = to_encode.split('').reverse().join('');  // Reverse the string
        const final_str = btoa(reversed);  // Base64 encode
        const ret = btoa(final_str + "_" + timestamp);
        const r =  ret.split('').reverse().join('')  // Add second timestamp and encode again
        return r;
    }
    return token
}
